<template>
  <section class="post-wrapper">
    <PostContent :post="post" :title="post.title" :m-medias="mMedias" />
    <a
      v-if="pdfObject"
      class="button-download"
      icon-name="nomad:pdf"
      aria-label="Télécharger le pdf"
      download="download"
      :href="pdfObject.url"
      @click.prevent.capture="
        () => fetchAndDownloadPdf(pdfObject.url, slugFile)
      "
    >
      <icon class="icon" name="nomad:pdf"></icon>
    </a>
  </section>
</template>
<script lang="ts" setup>
import slugify from 'slugify';
import type { PostSchema } from '~/types/schema';
import { saveRecommendationOpenedAt } from '~/lib/recommendation';
import { fetchAndDownloadPdf } from '~/lib/utils/download';
interface Props {
  post: PostSchema;
  pdfObject: MediaSchema;
  mMedias: Map<string, MediaSchema>;
}
const props = defineProps({
  post: null,
  pdfObject: null,
  mMedias: null
});

const { $db } = useNuxtApp();

const { disciplineId } = inject(INJECT_CATEGORY_PAGE);

const { category } = inject(INJECT_MODAL_CATEGORY);

useAppEventPost(category, disciplineId, props.post);

saveRecommendationOpenedAt($db, 'post', props.post.id);

const slugFile = computed(() => {
  return slugify(`${category.value.title}-${props.post.title}`).toLowerCase();
});
</script>
<style lang="scss" scoped>
.post-wrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  max-width: 128rem;
  height: 100%;
  margin: 0 auto;
  padding: 2rem;
  overflow: visible;
  background-color: var(--color_neutral_50);
  @include above('l') {
    margin-top: 0;
    overflow-y: scroll;
  }
}
.button-download {
  display: flex;
  position: sticky;
  flex: 0 0 auto;
  align-items: center;
  align-self: flex-end;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background-color: var(--color_secondary_light);
  @include hover-focus-desktop {
    background-color: var(--color_secondary);
    color: var(--color_neutral_25);
  }
}
</style>
